import { createSlice } from '@reduxjs/toolkit';

import { EnvironmentState } from '@paragon/environment-tools';
import { LogInDataState } from '@paragon/login-tools';

interface ThemeState {
  readonly useDarkTheme: boolean;
}

const initialState: ThemeState = {
  useDarkTheme: true,
};

const themeSlice = createSlice({
  name: 'theme',
  initialState,
  reducers: {
    toggleDarkTheme: (state) => {
      state.useDarkTheme = !state.useDarkTheme;
    },
  },
});

export const { toggleDarkTheme } = themeSlice.actions;
export const theme = themeSlice.reducer;

export interface ThemeSliceState {
  readonly environment: EnvironmentState;
  readonly logInData: LogInDataState;
  readonly theme: ThemeState;
}
